module.exports = "<h3 md-dialog-title>{{ title }}</h3>\n\n<md-dialog-content>\n  <p>{{ message }}</p>\n</md-dialog-content>\n\n<md-dialog-actions align=\"end\">\n  <button md-button (click)=\"ok()\" color=\"accent\">COntinuer</button>\n</md-dialog-actions>\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/dialog/alert-dialog/alert-dialog.component.html
// module id = ../../../../../src/app/dialog/alert-dialog/alert-dialog.component.html
// module chunks = 4